<template>
  <form
    @submit.prevent="confirmMethod"
    action="#"
  >
    <div id="payment-method"></div>

    <button
      :class="[
        'mt-3 font-medium text-white w-full rounded px-4 h-11 flex justify-center items-center focus:ring focus:ring-primary-100',
        loading ? 'bg-gray-200 cursor-not-allowed' : 'bg-primary-600 hover:bg-primary-500',
      ]"
      :disabled="loading"
    >
      <span v-if="!loading">Save Payment Method</span>
      <client-loading-indicator
        styled
        v-else
      />
    </button>
  </form>
</template>

<script>
import paymentMethodRequest from "../../repository/paymentMethodRequest"
import ClientLoadingIndicator from "../../../ClientPortal/client_auth/components/client-loading-indicator.vue"

export default {
  name: "PortalStripeMethodRequestForm",

  components: { ClientLoadingIndicator },

  props: {
    paymentRequestData: { type: Object, required: true },
    color: { type: String },
  },

  data() {
    return {
      loading: false,
      stripe: null,
      stripeElements: null,
      message: null,
    }
  },

  mounted() {
    this.setupStripe()
  },

  computed: {
    intent() {
      return this.paymentRequestData.intent
    },
  },

  methods: {
    setupStripe() {
      this.stripe = Stripe(this.intent.stripe_key, {
        stripeAccount: this.intent.provider_id,
      })
      this.stripeElements = this.stripe.elements({
        clientSecret: this.intent.client_secret,
        appearance: {
          variables: { colorPrimary: this.color },
        },
      })
      const element = this.stripeElements.create("payment", {
        layout: { type: "tabs" },
      })
      element.mount("#payment-method")
    },

    async confirmMethod() {
      this.message = null

      if (!this.stripe) {
        return
      }

      this.loading = true
      try {
        const { error } = await this.stripeElements.submit()

        if (error) {
          this.loading = false
          return
        }

        this.stripe
          .confirmSetup({
            elements: this.stripeElements,
            redirect: "if_required",
          })
          .then((result) => {
            if (result.error) {
              if (result.error.message) {
                this.message = result.error.message
              }

              this.loading = false

              return
            }

            this.$nextTick(() => this.paymentMethodApproved(result.setupIntent))
          })
      } catch (error) {
        this.$alert("Unable to process payment information. Please try again.")
        console.error(error)
        this.loading = false
      }
    },

    async paymentMethodApproved(intent) {
      this.loading = true

      try {
        const params = this.$route.params
        await paymentMethodRequest.complete({
          ...params,
          setup_intent_id: intent.id,
        })
        this.$emit("approve")
      } catch (e) {
        console.error(e)
      }

      this.loading = false
    },
  },
}
</script>

<style scoped></style>
